import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getShareClass } from '../shareclass.routes';
import { GetShareClassParams, ShareClassModel } from '../types';

// Query Hooks

/**
 * Hook to fetch share class information
 * @param params - Query parameters including client_id, fund_id (optional), share_class_id (optional), and only_active_share_class
 * @param options - Additional query options extending UseQueryOptions
 */
export const useShareClass = (
  params: GetShareClassParams,
  options?: Omit<
    UseQueryOptions<
      ShareClassModel[],
      Error,
      ShareClassModel[],
      (string | undefined)[]
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: [params.client_id, params.fund_id, params.share_class_id],
    queryFn: () => getShareClass(params),
    enabled: !!params.client_id,
    staleTime: options?.staleTime ?? 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook to fetch all share classes for a client
 * @param params - Query parameters including client_id and only_active_share_class
 */
export const useAllShareClasses = (params: Omit<GetShareClassParams, 'fund_id' | 'share_class_id'>) => {
  return useQuery({
    queryKey: ['all-share-classes', params.client_id],
    queryFn: () => getShareClass(params),
  });
};
